var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnityLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 43,
    viewBox: "0 0 114 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6693 13.1922H59.6911V22.5035C59.6911 24.9 58.7176 26.8039 55.8627 26.8039C53.0359 26.8323 52.2215 24.8715 52.2215 22.3803V13.1922H48.234V23.4033C48.234 26.3492 49.2637 30.5644 54.7395 30.5928C57.7442 30.6212 59.2325 29.1435 59.9345 27.8269V30.0718H63.6693V13.1922ZM65.2512 30.0718H69.2293V20.7606C69.2293 18.3925 70.2028 16.4886 73.0296 16.4602C75.8284 16.4602 76.6428 18.3925 76.6428 20.9216V30.0718H80.6209V19.8986C80.6209 16.9148 79.5913 12.7092 74.1529 12.6713C71.1763 12.6428 69.688 14.111 68.9579 15.4372C68.986 14.6415 68.986 13.9311 68.986 13.1922H65.2512V30.0718ZM82.1467 30.0718H86.1248V13.1922H82.1467V30.0718ZM82.1467 10.9189H86.1248V7.31944H82.1467V10.9189ZM90.2902 30.0718H94.2683V16.2991H97.1233L95.9438 13.1922H94.2683V7.31944H90.2902V13.1922H87.5289V16.2991H90.2902V30.0718ZM100.97 35.973H105.22L114 13.1922H109.75L105.744 24.4169L101.672 13.1922H97.4228L103.713 29.4277L100.97 35.973ZM26.415 21.4805L33.6786 8.78764L37.1888 21.4805L33.6786 34.1733L26.415 21.4805ZM22.8768 23.5359L30.1404 36.2288L17.4852 32.9514L8.34009 23.5359H22.8768ZM30.1404 6.72268L22.8768 19.4155H8.34009L17.4852 10.0001L30.1404 6.72268ZM40.5117 17.1611L36.0749 0.480469L19.5351 4.95137L17.0827 9.30861L12.1123 9.27071L0 21.4805L12.1123 33.6902L17.0827 33.6523L19.5351 38.0096L36.0749 42.4805L40.5117 25.7998L37.9938 21.4805L40.5117 17.1611Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 42,
    fill: "white",
    transform: "translate(0 0.480469)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityLogo);
export default __webpack_public_path__ + "static/media/unity-logo.75bb226a4fc8d18146647f7912b54dfa.svg";
export { ForwardRef as ReactComponent };